module.exports = __webpack_public_path__ + "static/media/Customer Side Update -1_1576243035263.ce7f4eed.mp4";